import type { ComponentProps, CSSProperties, PropsWithChildren, ReactNode } from "react"
import { cx } from "classix"

export type DataRowProps = {
	/** заголовок */
	title: string | number
	/** выводимое содержимое (также можно использовать content или дочерние элементы) */
	value?: string | number
	/** выводимое содержимое (также можно использовать value или дочерние элементы) */
	content?: ReactNode
	/** стиль заголовка */
	titleStyle?: CSSProperties
	/** стиль содержимого */
	contentStyle?: CSSProperties
	/** стиль корневого элемента */
	style?: CSSProperties
} & Omit<ComponentProps<"div">, "style" | "title">

/**
 * Используется для вывода некоторого контента, предваряемого подписью
 */
export function LabeledContent({
	className,
	title,
	value,
	content,
	children,
	titleStyle = {},
	contentStyle = {},
	style = {},
	...props
}: PropsWithChildren<DataRowProps>) {
	const c = value || content || children

	return c ? (
		<div className={cx(className, "flex flex-row items-center gap-[1rem] flex-wrap")} style={style} {...props}>
			<label style={titleStyle}>{title}:</label>
			<div style={contentStyle}>{c}</div>
		</div>
	) : null
}
